// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"w1-z","refreshPageWarning":"x1-z","redirectMessageText":"y1-z"};